export const joinClasses = (...args: (string | undefined)[]) => {
    const classes = args
        .filter(arg => typeof arg === 'string')
        .join(' ')
        .trim();
    return classes;
};
